import { ThemeState } from "../types";

const initialState: ThemeState = {
  accentColor: "#0057EA",
  secondaryColor: "#FFFFFF",
  fontFamily: {
    name: "Poppins",
    url:
      "https://fonts.googleapis.com/css2?family=Poppins:wght@500&display=swap",
  },

  isCustomizationEnabled: false,
  gradient: {
    start: "#0057EA",
    stop: "#22C3F7",
  },
  illustrations: {
    welcome: {
      name: "welcome",
      base64Image: "",
    },
    prepareSelfie: {
      name: "prepareSelfie",
      base64Image: "",
    },
    chooseCountry: {
      name: "chooseCountry",
      base64Image: "",
    },
    driversLicenseFront: {
      name: "driversLicenseFront",
      base64Image: "",
    },
    driversLicenseBack: {
      name: "driversLicenseBack",
      base64Image: "",
    },
    nationalIdFront: {
      name: "nationalIdFront",
      base64Image: "",
    },
    nationalIdBack: {
      name: "nationalIdBack",
      base64Image: "",
    },
    passport: {
      name: "passport",
      base64Image: "",
    },
  },
};

export default initialState;
